module.exports = __webpack_public_path__ + "img/sierras1.9322d22.jpg";